import React from 'react';
import { connect } from 'react-redux';
import i18n from '../../i18n/i18n';
import axios from '../../utils/AxiosWrapper';
import { Button, IconButton, withStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setInitialState, addSector } from '../../actions/sectors/SectorsActions';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { wentWrong } from '../../utils/ToastConfig';

const styles = theme => ({
})
export class AddSector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sectorObj: props.edit && props.data ? { ...props.data } : { naziv: '' }
        }
    }

    componentDidMount() {
        if (this.props.edit && this.props.data) {
            console.log("Editing data:", this.props.data); // Dodaj ovo da vidiš ceo objekat
            this.setState({ sectorObj: { ...this.props.data } });
        } else {
            this.setState({ sectorObj: { naziv: '' } });
        }
    }

    componentDidUpdate(prevProps) {
        // Kada pređeš iz add u edit ili se promeni data
        if (this.props.edit && this.props.data && prevProps.data !== this.props.data) {
            this.setState({ sectorObj: { ...this.props.data } });
        }
        // Kada pređeš iz edit u add (edit=false, data=null)
        if (!this.props.edit && (!this.props.data || !this.props.data.naziv) && (prevProps.edit || prevProps.data)) {
            this.setState({ sectorObj: { naziv: '' } });
        }
    }

    // componentDidUpdate(prevProps) {
    //     const { sectorPostingFailed, setInitialState } = this.props;
    //     if (prevProps.sectorPostingFailed !== sectorPostingFailed) {
    //         toast.error(i18n.t('Something went wrong, please try again!'), {
    //             position: "top-center",
    //             autoClose: 5000,
    //             hideProgressBar: true,
    //             closeOnClick: true,
    //             pauseOnHover: false,
    //             draggable: false,
    //             draggablePercent: 80
    //         });
    //         setInitialState('sectorPostingFailed');
    //     }
    // }


    addSector = () => {
        const { edit } = this.props;
        const payload = { naziv: this.state.sectorObj.naziv };
        const naziv = (this.state.sectorObj.naziv || '').trim();
        if (!naziv) {
            toast.error(i18n.t('Please enter sector name!'), {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
            });
            return;
        }
        if (edit) {
            // Pre update poziva proverimo da li postoji id
            if (!this.state.sectorObj.id) {
                console.error("Edit mode: id is missing in sectorObj", this.state.sectorObj);
                wentWrong('Sector ID missing for update');
                return;
            }
            console.log("Performing UPDATE with payload:", { id: this.state.sectorObj.id, ...payload });
            axios.put('api/sektor/update', { id: this.state.sectorObj.id, ...payload })
                .then(res => {
                    console.log("Update success:", res);
                    this.props.handleCreate();  // Callback koji zatvara modal i osvežava tabelu
                })
                .catch(err => {
                    wentWrong('Failed to update sector');
                    console.log('Update sector error: ', err);
                });
        } else {
            // Kreiraj novi sektor
            axios.post('api/sektor/create', payload)
                .then(res => {
                    console.log("Create success:", res);
                    this.props.handleCreate();
                })
                .catch(err => {
                    if (err.response && err.response.status === 409) {
                        wentWrong(i18n.t('Sector with this name already exists!'));
                    } else {
                        wentWrong('Failed to add sector');
                    }
                });
        }
    };

    handleChangeValue = name => event => {
        let sectorObj = { ...this.state.sectorObj };
        sectorObj[name] = event.target.value;
        this.setState({ sectorObj });
    };


    render() {
        const { add, handleClose, edit, theme } = this.props;
        const { sectorObj } = this.state;
        return (
            <div style={{ padding: 20 }}>
                <Dialog
                    open={add}
                    onClose={handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="xs"
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle disableTypography={true} style={{ background: theme.palette.secondary.dark }} className="responsive-dialog-title">{edit ? i18n.t('Edit sector') : i18n.t('Add sector')}
                        <IconButton onClick={handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container justify="space-between" alignContent="space-between" spacing={16}>
                            <Grid item>
                                <TextField
                                    required
                                    label={i18n.t('Title')}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    value={sectorObj.naziv}
                                    onChange={this.handleChangeValue('naziv')}
                                />
                            </Grid>
                            <Grid item xs>
                                <Button
                                    style={{ alignSelf: 'center', color: 'white' }}
                                    variant="contained"
                                    color="primary"
                                    onClick={this.addSector}
                                >
                                    {edit ? i18n.t('Save') : i18n.t('Add')}
                                </Button>
                            </Grid>
                            <Grid item xs={3}>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            </div>

        )
    }
};

function mapStateToProps(state) {
    return {
        sectorPosting: state.sectorReducer.sectorPosting,
        sectorPostingFailed: state.sectorReducer.sectorPostingFailed,
        sectorObj: state.sectorReducer.sectorObj,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setInitialState: (component) => dispatch(setInitialState(component)),
        addSector: (sectorObj) => dispatch(addSector(sectorObj)),
    }
}

export default withStyles(styles, { withTheme: true })(connect(
    mapStateToProps,
    mapDispatchToProps
)(AddSector))